module.exports = __webpack_public_path__ + "img/typhoon-logo-white.8f8d0a2a.png";